(function () {
  var IS_HU = window.location.hostname.indexOf('waidzeit.hu') !== -1;
  var VISIBLE_PROP_KEY = IS_HU ? 'Termékhez' : 'Pre produkt';

  function findLine(variantId, lineKey, propertyKey) {
    return fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => cart.items.find((i) => i.variant_id === Number(variantId) && i.properties && i.properties[propertyKey] === lineKey));
  }

  async function addUpsell(variantId, productTitle, lineKey, propertyKey) {
    const properties = {};
    properties[VISIBLE_PROP_KEY] = productTitle;
    properties[propertyKey] = lineKey;
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: 1,
            properties: properties,
          },
        ],
      }),
    });
  }

  async function removeUpsell(variantId, lineKey, propertyKey) {
    const line = await findLine(variantId, lineKey, propertyKey);
    if (!line) return;
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: line.key, quantity: 0 }),
    });
  }

  function refreshCart() {
    if (window.location.pathname.indexOf('/cart') === 0) {
      window.location.reload();
    } else {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }
  }

  document.addEventListener(
    'change',
    async function (e) {
      const target = e.target;
      if (!target.matches('.cart-upsell__radio, .cart-upsell__checkbox')) return;

      const wrapper = target.closest('[data-cart-upsell]');
      const productTitle = wrapper.getAttribute('data-product-title');
      const lineKey = wrapper.getAttribute('data-line-key');
      const propertyKey = wrapper.getAttribute('data-property-key') || '_Pro položku';
      const variantId = target.getAttribute('data-variant-id');

      target.disabled = true;

      if (target.type === 'radio') {
        const radios = wrapper.querySelectorAll('.cart-upsell__radio');
        for (const r of radios) {
          if (r !== target) {
            await removeUpsell(r.getAttribute('data-variant-id'), lineKey, propertyKey);
          }
        }
        await addUpsell(variantId, productTitle, lineKey, propertyKey);
      } else {
        if (target.checked) {
          await addUpsell(variantId, productTitle, lineKey, propertyKey);
        } else {
          await removeUpsell(variantId, lineKey, propertyKey);
        }
      }

      target.disabled = false;
      refreshCart();
    },
    true
  );

  var lockedScrollY = 0;
  function lockBodyScroll() {
    lockedScrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + lockedScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }
  function unlockBodyScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, lockedScrollY);
  }

  const protectionModal = document.getElementById('protection-info-modal');
  if (protectionModal) {
    protectionModal.addEventListener('close', unlockBodyScroll);
  }

  document.addEventListener('click', function (e) {
    const openBtn = e.target.closest('[data-upsell-info-open]');
    if (openBtn) {
      const templateId = 'upsell-info-' + openBtn.getAttribute('data-upsell-info-open');
      const template = document.getElementById(templateId);
      const modal = document.getElementById('protection-info-modal');
      const body = document.getElementById('cart-upsell-info-body');
      if (template && modal && body) {
        body.innerHTML = '';
        body.appendChild(template.content.cloneNode(true));
        lockBodyScroll();
        modal.showModal();
      }
      return;
    }
    const closeBtn = e.target.closest('[data-upsell-info-close]');
    if (closeBtn) {
      const modal = closeBtn.closest('dialog');
      if (modal) modal.close();
      return;
    }
    if (e.target.tagName === 'DIALOG') {
      e.target.close();
    }
  });
})();
